$('.slider-wrapper').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  dots: true,
  slideEndAnimation: true,
  lazyLoad: 'ondemand',
  slideEndAnimation: true,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 1      
    }    
}  
]	
}
);;










document.addEventListener("DOMContentLoaded", function () {
    const whatsapp = document.getElementById("psWhatsappWidget");

    whatsapp.style.opacity = "0";
    whatsapp.style.transform = "translateY(40px)";

    setTimeout(() => {
        whatsapp.style.transition = "all .6s ease";
        whatsapp.style.opacity = "1";
        whatsapp.style.transform = "translateY(0)";
    }, 300);
});